// src/components/ServiceDatePicker.tsx
//
// The MEDICAL SERVICE date field — `DatePicker` with its popover speaking of a
// "service date", because on this product that date decides which entitlement
// applies and the control's own words should say which
// date it is asking for.
//
// ★ 2026-08-26 (Wave 26) — the implementation moved to `DatePicker.tsx`, which
// is now the ONE date control in the console (its header says why). This file
// keeps the name every service-date screen imports, the `singaporeToday()`
// export `ServiceDatePicker.test.ts` pins, and the words. Nothing else.
import { DatePicker, type DatePickerProps } from './DatePicker'

export { singaporeToday } from './DatePicker'

export type ServiceDatePickerProps = Omit<DatePickerProps, 'subject'>

export function ServiceDatePicker(props: ServiceDatePickerProps) {
  return <DatePicker {...props} subject="service date" />
}
